import { configureStore } from "@reduxjs/toolkit";
import appConfigSliceReducer from "stores/appConfigSlice";
import windowSizeSliceReducer from "stores/windowSizeSlice";
import collectListSliceReducer from "stores/collectSlice";
import firstSliceReducer from "stores/firstSlice";
import historyListSliceReducer from "stores/historySlice";
import panelSliceReducer from "stores/panelSlice";
import removeListReducer from "stores/removeListSlice";
import selecterSliceReducer from "stores/selecterSlice";
// import videoListReducer from "stores/videoListSlice";

export default configureStore({
  reducer: {
    appConfigHandle: appConfigSliceReducer,
    windowSizeHandle: windowSizeSliceReducer,
    // userHandle: userSliceReducer,
    selecterHandle: selecterSliceReducer,
    collectListHandle: collectListSliceReducer,
    historyListHandle: historyListSliceReducer,
    // videoListHandle: videoListReducer,
    removeListHandle: removeListReducer,
    firsthandle: firstSliceReducer,
    panelHandle: panelSliceReducer,
  },
});
